import {
  UPLOAD_POLICIES,
  UPLOAD_PURPOSE_MARKETPLACE_PARTNER_PREFLIGHT,
} from "@nexus/contracts";

const MB = 1024 * 1024;
const GB = 1024 * MB;

function formatPartnerVideoMax(bytes: number): string {
  if (bytes >= GB && bytes % GB === 0) {
    return `${bytes / GB} GB`;
  }
  return `${Math.round(bytes / MB)} MB`;
}

export function getMarketplacePartnerPreflightUploadConstraints() {
  const policy = UPLOAD_POLICIES[UPLOAD_PURPOSE_MARKETPLACE_PARTNER_PREFLIGHT];
  const videoMax = policy.maxSizeBytesByContentType["video/mp4"] ?? 1024 * 1024 * 1024;

  return {
    accept: policy.allowedContentTypes.join(","),
    formats: "MP4, MOV",
    videoMax: formatPartnerVideoMax(videoMax),
  };
}
